<template>
  <Layout>
    <PageHeader
      :title="title"
      moda_title="DATOS DEL TORNEO"
      ref="pageForm"
      :items="items"
      :isAdmin="onlyAdminRole"
    >
      <template>
        <PageForm :typeform="typeform" @closeModa="closeModa" />
      </template>
    </PageHeader>
    <ConfigPositions ref="configPositionsC" />
    <ConfigRetries ref="configRetriesC" />
    <ConfigOperators ref="configOperatorsC" />
    <div class="row mt-4">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('filter.show') }}&nbsp;
            <vs-select v-model="perPage" color="dark" class="shadow-lg">
              <vs-option
                v-for="(op, index) in pageOptions"
                :key="index"
                :label="op"
                :value="op"
                >{{ op }}</vs-option
              >
            </vs-select>
            &nbsp;{{ $t('filter.entries') }}
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            {{ $t('filter.search') }}:
            <vs-input
              v-model="filter"
              type="search"
              placeholder="Buscar..."
              primary
              class="shadow-lg"
            ></vs-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive mb-0">
      <b-overlay :show="overlayLoader" rounded="sm" z-index="1000">
        <b-table
          id="tournaments-table"
          :items="tableData"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :filter-included-fields="filterOn"
        >
          <template #cell(logo)="data">
            <b-img
              :src="data.item.logo || '@/assets/images/users/pngegg.png'"
              height="80px"
              class="logo-img"
              @error.once="(e) => handleError(e)"
            ></b-img>
          </template>
          <!-- Column: Actions -->

          <template #cell(actions)="data">
            <div class="action-btn-container">
              <b-dropdown
                variant="link"
                no-caret
                menu-class="position-absolute start-3 top-2"
              >
                <template #button-content>
                  <i class="fa fa-fw fa-bars font-size-16" />
                </template>
                <div v-if="onlyAdminRole">
                  <b-dropdown-item @click="edit(data.item)">
                    <i class="uil-edit m-2 font-size-18" />
                    <span class="align-middle ml-5">{{
                      $t('actions.subItems.edit').toUpperCase()
                    }}</span>
                  </b-dropdown-item>
                </div>
                <div v-if="onlyAdminRole">
                  <b-dropdown-item @click="configPositions(data.item)">
                    <i class="uil-edit m-2 font-size-18" />
                    <span class="align-middle ml-5">
                      CONFIGURAR POSICIONES
                    </span>
                  </b-dropdown-item>
                </div>
                <div v-if="onlyAdminRole">
                  <b-dropdown-item @click="configRetries(data.item)">
                    <i class="uil-edit m-2 font-size-18" />
                    <span class="align-middle ml-5">
                      CONFIGURAR PORCENTAJE DE REINTENTOS
                    </span>
                  </b-dropdown-item>
                </div>
                <div v-if="onlyAdminRole">
                  <b-dropdown-item @click="configOperators(data.item)">
                    <i class="uil-edit m-2 font-size-18" />
                    <span class="align-middle ml-5">
                      CONFIGURAR OPERADORES
                    </span>
                  </b-dropdown-item>
                </div>
                <div v-if="onlyAdminRole">
                  <b-dropdown-item @click="remove(data.item)">
                    <i class="mdi mdi-delete-outline m-2 font-size-18" />
                    <span class="align-middle ml-5">{{
                      $t('actions.subItems.delete').toUpperCase()
                    }}</span>
                  </b-dropdown-item>
                </div>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="tournaments-table"
            ></b-pagination>
          </ul>
        </div>
      </b-overlay>
    </div>
  </Layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import {
  PageForm,
  ConfigPositions,
  ConfigRetries,
  ConfigOperators,
} from './components';
import { TournamentEdit } from '@/state/entities/Tournament';

export default {
  components: {
    Layout,
    PageHeader,
    PageForm,
    ConfigPositions,
    ConfigRetries,
    ConfigOperators,
  },
  data() {
    return {
      title: 'TORNEOS',
      items: [],
      typeform: {
        type: 'free',
        game: 'poker',
        hasMaxPlayers: false,
        playerRetry: false,
        playerInitialPoints: 2000,
        ticketValue: 0,
      },
      // TABLE
      filterOn: [],
      filter: null,
      sortBy: 'startDate',
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      // TABLE
      overlayLoader: false,
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    ...mapGetters({
      onlyAdminRole: 'user/onlyAdminRole',
      tableData: 'tournaments/getData',
      fields: 'tournaments/getFields',
      success: 'tournaments/isSuccess',
      text: 'tournaments/getMessage',
      getPositions: 'tournaments/getPositions',
      getRetries: 'tournaments/getRetries',
      getOperators: 'operators/getOperators',
      getOperatorsTournament: 'tournaments/getOperators',
    }),
  },
  methods: {
    edit(data) {
      this.typeform = new TournamentEdit(data);
      this.$refs.pageForm.modal = true;
    },
    closeModa() {
      this.$refs.pageForm.modal = false;
      this.typeform = {
        type: 'free',
        game: 'poker',
        hasMaxPlayers: false,
        playerCanRetry: false,
        playerInitialPoints: 2000,
        ticketValue: 0,
      };

      this.getTournaments();
    },
    async configPositions(item) {
      await this.fetchPositions(item.id);

      this.$refs.configPositionsC.positions = JSON.parse(
        JSON.stringify(this.getPositions)
      );
      this.$refs.configPositionsC.tournament = item.id;
      this.$refs.configPositionsC.modal = true;
    },
    async configRetries(item) {
      await this.fetchRetries(item.id);

      this.$refs.configRetriesC.retries = JSON.parse(
        JSON.stringify(this.getRetries)
      );

      this.$refs.configRetriesC.tournament = item.id;
      this.$refs.configRetriesC.modal = true;
    },

    async configOperators(item) {
      await this.fetchOperatorsTournament(item.id);

      const options = this.getOperators.map((op) => ({
        name: op.name,
        operator: op._id,
      }));

      for (const op of options) {
        const operator = this.getOperatorsTournament.find(
          (o) => o.operator === op.operator
        );
        if (operator) {
          op.id = operator.id;
        }
      }

      const values = this.getOperatorsTournament.map((op) => ({
        name: this.getOperators.find((o) => o._id === op.operator).name,
        operator: op.operator,
        id: op.id,
      }));

      this.$refs.configOperatorsC.values = values;
      this.$refs.configOperatorsC.options = options;
      this.$refs.configOperatorsC.tournament = item.id;
      this.$refs.configOperatorsC.modal = true;
    },

    async remove(item) {
      const { isConfirmed } = await this.$swal.fire({
        title: '¿Estás seguro?',
        text: `¿Deseas eliminar el torneo ${item.name}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (!isConfirmed) return;

      await this.deleteTournament(item.id);

      if (!this.success)
        return this.$swal.fire({
          title: 'Error',
          text: this.text,
          icon: 'error',
        });

      this.$swal.fire({
        title: 'Éxito',
        text: this.text,
        icon: 'success',
      });
      this.getTournaments();
    },
    async getTournaments() {
      this.overlayLoader = true;
      await this.fetchTournaments({});
      this.overlayLoader = false;
    },
    ...mapActions({
      handleError: 'games/handleLogoError',
      fetchTournaments: 'tournaments/fetchTournaments',
      deleteTournament: 'tournaments/deleteTournament',
      findGames: 'games/findGames',
      fetchPositions: 'tournaments/fetchPositions',
      fetchRetries: 'tournaments/fetchRetries',
      fetchOperators: 'operators/fetchOperators',
      fetchOperatorsTournament: 'tournaments/fetchOperators',
    }),
  },
  mounted() {
    this.getTournaments();

    const options = { path: 'roulettes', options: {}, type: 'roulettes' };

    this.findGames(options);
    this.fetchOperators({ options: {} });
  },
};
</script>
